import Swiper from 'swiper';

if (document.querySelector('.js-calendar-swiper')) {
    const dayButtons = document.querySelectorAll('.js-calendar-day-btn');
    const filterButtons = document.querySelectorAll('.js-calendar-filter-btn');
    const tableItems = document.querySelectorAll('.js-calendar-item');
    const swiper = new Swiper('.js-calendar-swiper', {
        autoHeight: true,
		allowTouchMove: false,
    });


    dayButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            swiper.slideTo(btn.dataset.slide);

            dayButtons.forEach(b => {
                b.classList.remove('_is-active');
            });
    
            btn.classList.add('_is-active');
        });
    });


    filterButtons.forEach(btn => {
        const filter = btn.dataset.filter;

        btn.addEventListener('click', () => {
            if (filter == 'all') {
                tableItems.forEach(item => {
                    item.classList.remove('_is-hidden');
                });
            } else {
                tableItems.forEach(item => {
                    if (item.dataset.filter === filter) {
                        item.classList.remove('_is-hidden');
                    } else {
                        item.classList.add('_is-hidden');
                    }
                });
            }

            swiper.update();

            filterButtons.forEach(b => {
                b.classList.remove('_is-active');
            });
    
            btn.classList.add('_is-active');
        });
    });
}
